import { Card, FooterMenu, HeaderMenu, PaginationData } from "components";
import { FilterSetItem, TableSetItemPrice } from "./components";
import { FormProvider, useForm } from "react-hook-form";
import {isItemChanged, SetItemPriceFormType, setItemValidation, useList } from "./utils";
import { useEffect, useState } from "react";
import { default_pagination_value, useApi } from "utils";
import { PaginationState } from "types";
import { SetItemPriceType } from "./types";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { PERMISION } from "security";

export interface PaginationType extends PaginationState {
    group_id?: string
}

export default function SetItemPrice() {
    const api = useApi()

    const [pagination, setPagination] = useState<PaginationType>({ ...default_pagination_value, group_id: "" })
    const { data, isLoading, refetch } = useList(pagination)
    const [originalData, setOriginalData] = useState<SetItemPriceType[]>([])

    const method = useForm<SetItemPriceFormType>({
        defaultValues: {
            setItem: []
        },
        resolver: yupResolver(setItemValidation)
    })

    useEffect(() => {
        if (data?.items?.length) {
            setOriginalData(data.items)
            method.reset({
                setItem: data.items.map((item: SetItemPriceType) => {
                    return {
                        product_id: item.product_id.toString(),
                        distributor_price: item.distributor_price || 0,
                        factory_price: item.factory_price || 0,
                        online_price: item.online_price || 0,
                        price_retail: item.price_retail || 0,
                        special_arrangement_price: item.special_arrangement_price || 0,
                        wholesales_price: item.wholesales_price || 0,
                    }
                })
            });
        }

        // eslint-disable-next-line
    }, [data?.items]);

    const onSubmit = (value: SetItemPriceFormType) => {

        const dataChanged = isItemChanged(value, originalData)

        if (dataChanged && dataChanged.length === 0) {
            toast.error("No changes detected")
        }
        
        const finalData = dataChanged?.map(item => ({
            product_id: item.product_id,
            price_retail: item.price_retail,
            wholesales_price: item.wholesales_price,
            distributor_price: item.distributor_price,
            factory_price: item.factory_price,
            online_price: item.online_price,
            special_arrangement_price: item.special_arrangement_price,
        }))

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/product/updateitemprice", finalData),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message
                }
            ).then(() => {
                refetch()
            }).catch(() => { }).finally(resolve)
        })
    }


    return (
        <section className="container my-2">
            <HeaderMenu title="SET ITEM PRICE" />

            <section className="mt-2">
                <Card>
                    <Card.Body>
                        <FilterSetItem
                            pagination={pagination}
                            handleSearch={(value: any) => setPagination({ ...pagination, keyword: value, page: 1 })}
                            handleGroup={(value: any) => setPagination({ ...pagination, group_id: value, page: 1 })}
                        />

                    </Card.Body>
                </Card>
            </section>


            <section className="mt-2">
                <Card>
                    <Card.Body>
                        <FormProvider {...method}>
                            <TableSetItemPrice
                                isLoading={isLoading}
                                pagination={pagination}
                                refetch={refetch}
                                data={data}
                            />
                        </FormProvider>
                        <div>
                            <PaginationData
                                data={data}
                                pagination={pagination}
                                setPagination={setPagination}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </section>

            <section className="mt-2">
                <FooterMenu
                    hasCancelButton
                    save={{
                        actiontype: "save",
                        permission: PERMISION.INVENTORY.TRANSACTION.SET_ITEM_PRICE.CREATE,
                        type: "button",
                        color: "primary",
                        onClick: method.handleSubmit(onSubmit),
                        loading: method.formState.isSubmitting ? "true" : undefined
                    }}
                />
            </section>

        </section>
    )
}